import { connect, MapStateToProps } from 'react-redux';
import { Props } from './TopicListPage';
import { AppState } from '../../../../types/store';
import { getTopTopics } from '../../../../selectors/page';
import { getStreamItems } from '../../../../selectors/stream';
import { PAGE_STREAM_ID } from '../../../../../constants';
import { PapiTopic } from '@wix/da-papi-types';

export type StateProps = Pick<Props, 'topTopics' | 'allTopics'>;
export type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  return {
    topTopics: getTopTopics(state),
    allTopics: getStreamItems(state, PAGE_STREAM_ID) as unknown as PapiTopic[],
  };
};

export default connect(mapStateToProps);
